import { render, staticRenderFns } from "./client-unit-tabs.vue?vue&type=template&id=7d74646c&scoped=true&lang=pug&"
import script from "./client-unit-tabs.vue?vue&type=script&lang=ts&"
export * from "./client-unit-tabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d74646c",
  null
  
)

export default component.exports